import dates from "@/services/date";
export default {
  methods: {
    hoursPassed: function(timeString) {
      return dates.timeToNow(dates.parseJsonDate(timeString));
    }
  }
}
